import { setToken } from 'shared-components/src/utils/auth';

export const refresh = async () => {
  // Refresh token is now in HttpOnly cookie, browser sends it automatically
  return fetch('/api/refresh', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    credentials: 'include', // Important: include cookies in request
  })
    .then(res => {
      if (!res.ok)
        throw new Error(
          'Unable to refresh session. Please try again or wait for login screen'
        );
      return res.json();
    })
    .then(({ exp, token }) => {
      setToken(token, exp);
    });
};

export const login = async (email, password) => {
  return fetch('/api/login', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    credentials: 'include', // Important: allow cookies to be set
    body: JSON.stringify({ email, password }),
  })
    .then(res => {
      if (!res.ok) throw new Error('Failed to Login User');
      return res.json();
    })
    .then((body) => {
      const { exp, token, mfa_required, mfa_registered, user_sub, secret_code, session, user_name } = body;

      // Store access token - refresh token is now in HttpOnly cookie
      setToken(token, exp);

      // Handle MFA flow based on login response
      if (mfa_required) {
        if (mfa_registered === false) {
          // User needs to set up MFA - store setup data
          sessionStorage.setItem('mfa_setup_data', JSON.stringify({
            secret_code,
            session,
            user_sub,
            user_name
          }));
          setTimeout(() => {
            window.location.href = '/auth/mfa-setup';
          }, 100);
        } else if (mfa_registered === true) {
          // User has MFA registered - store user_sub for verification
          sessionStorage.setItem('mfa_user_sub', user_sub);
          window.location.pathname = '/auth/mfa-verify';
        }
      } else {
        // No MFA required - go to dashboard
        window.location.pathname = '/';
      }
    });
};

export const forgotPassword = async (email, emailSent, updateEmailSent) => fetch('/api/v1/forgot_password', {
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  body: JSON.stringify({ email }),
})
  .then(res => {
    if (!res.ok) throw new Error('Failed to Request Password Reset');
    return res.json();
  })
  .then(updateEmailSent(true));

export const register = async payload => fetch('/api/v1/register_user', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
  body: JSON.stringify(payload),
}).then(res => {
  if (!res.ok) throw new Error('Failed to Register User');
  return res.json();
});

export const resetPassword = async payload => fetch('/api/v1/reset_password', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
  body: JSON.stringify(payload),
}).then(res => {
  if (!res.ok) throw new Error('Failed to Reset User Password');
  return res.json();
});
